/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：428__part-0
 */

"use strict"

import { rr, or, ir, ar, sr, cr, lr, ur, dr, pr, fr, wr, Tr, Sr } from "./index__part-7"
var r = {}
Object.defineProperty(r, "getSensorOrientationAzimuth", {
  get: function () {
    return rr
  }
})
Object.defineProperty(r, "getSensorOrientationPitch", {
  get: function () {
    return or
  }
})
Object.defineProperty(r, "getSensorOrientationRoll", {
  get: function () {
    return ir
  }
})
Object.defineProperty(r, "getSensorGravityX", {
  get: function () {
    return ar
  }
})
Object.defineProperty(r, "getSensorGravityY", {
  get: function () {
    return sr
  }
})
Object.defineProperty(r, "getSensorGravityZ", {
  get: function () {
    return cr
  }
})
Object.defineProperty(r, "getSensorRotationX", {
  get: function () {
    return lr
  }
})
Object.defineProperty(r, "getSensorRotationY", {
  get: function () {
    return ur
  }
})
Object.defineProperty(r, "getSensorRotationZ", {
  get: function () {
    return dr
  }
})
Object.defineProperty(r, "unsubscribeSensor", {
  get: function () {
    return pr
  }
})
Object.defineProperty(r, "subscribeSensor", {
  get: function () {
    return fr
  }
})
var o = {}
Object.defineProperty(o, "startSoundDetection", {
  get: function () {
    return wr
  }
})
Object.defineProperty(o, "stopSoundDetection", {
  get: function () {
    return Tr
  }
})
Object.defineProperty(o, "getVolumeSensorCurrentValue", {
  get: function () {
    return Sr
  }
})
export { r }
export { o }
